import React, { useState, useEffect } from "react";
import { useStateValue } from "../../../context/store";
import ContractModelsForm from "./contractModelsForm";
import { styles } from "./styles";
import { getContractTypeFormatByContractType } from "../../../actions/contract-type-actions";
import _ from "lodash";

const ContractModelsList = (props) => {
  const [{}, dispatch] = useStateValue();
  const id = props.id;
  const classes = styles();
  const [contractTypesFormats, setContractTypesFormats] = useState([]);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const getContractTypesFormatsAsync = async () => {
      const response = await getContractTypeFormatByContractType(id, dispatch);
      const orderList = _.sortBy(response?.data, function (contratTypeFormat) {
        return new Date(contratTypeFormat.creationDate);
      }).reverse();
      setContractTypesFormats(orderList);
    };
    getContractTypesFormatsAsync();
  }, [dispatch, id, refresh]);

  return (
    <React.Fragment>
      {contractTypesFormats &&
        contractTypesFormats.map((ctf) =>
          <ContractModelsForm
            data={ctf}
            history={props.history}
            setRefresh={setRefresh}
            refresh={refresh}
          />
        )}
    </React.Fragment>
  );
};

export default ContractModelsList;
